import React from 'react';
import BigNumber from 'bignumber.js';
import classNames from 'classnames';

const rangePresentations = {
  closed: { color: 'bg-cf-light-2', content: <div>Closed</div> },
  inRange: { color: 'bg-cf-green-1', content: <div>In range</div> },
  outOfRange: { color: 'bg-cf-orange-1', content: <div>Out of range</div> },
} as const;

const limitPresentations = {
  filled: { color: 'bg-cf-blue-2', content: <div>Filled</div> },
  canceled: { color: 'bg-cf-red-1', content: <div>Canceled</div> },
  partial: (fillPercentage: number) => ({
    color: 'bg-cf-orange-2',
    content: (
      <>
        <div className="text-cf-light-3">{fillPercentage.toFixed(0)}%</div>
        <div className="text-cf-light-2">filled</div>
      </>
    ),
  }),
} as const;

export const getPercentageFilled = (remaining: bigint, original: bigint) =>
  BigNumber(1)
    .minus(BigNumber(remaining.toString()).div(original.toString()))
    .times(100)
    .toNumber();

function OrderStatus({ color, content }: { color: string; content: React.ReactNode }) {
  return (
    <div className="flex items-center gap-x-2">
      <div className={classNames('h-[8px] w-[8px] rounded-full', color)} />
      {content}
    </div>
  );
}

export function RangerOrderStatus({
  isInRange,
  isRpcOrderOpen,
}: {
  isInRange: boolean;
  isRpcOrderOpen: boolean;
}) {
  let presentation: { color: string; content: React.ReactNode } = rangePresentations.closed;

  if (isRpcOrderOpen) {
    if (isInRange) {
      presentation = rangePresentations.inRange;
    } else {
      presentation = rangePresentations.outOfRange;
    }
  }

  return <OrderStatus color={presentation.color} content={presentation.content} />;
}

export function LimitOrderStatus({
  fillPercentage,
  isOrderOpen,
}: {
  fillPercentage: number;
  isOrderOpen: boolean;
}) {
  let presentation: { color: string; content: React.ReactNode } = limitPresentations.canceled;

  if (fillPercentage >= 100) {
    presentation = limitPresentations.filled;
  } else if (isOrderOpen || fillPercentage > 0) {
    presentation = limitPresentations.partial(fillPercentage);
  }

  return <OrderStatus color={presentation.color} content={presentation.content} />;
}
